export const MAIN_PAGE_URL = '/tracking'

export const SIGN_IN_PATH = '/login'

export const CHINA_CENTER_LATLNG = { lat: 34.32, lng: 108.55 }
